module.exports = __webpack_public_path__ + "img/PL08093.eac0828d.png";